import axios from "axios";
export default () => {
    const getCognitoConfig = async () => {
        const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/passwordless-login/cognito-info`, {
            method: 'GET',
        })
        return await response.json()
    }

    const setCookies = async (refreshToken, accessToken, idToken) => {
        const response = await axios.post(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/passwordless-login/set-cookies`, {
            refreshToken,
            accessToken,
            idToken
        })
        return response.data
    }

    return {
        getCognitoConfig,
        setCookies
    }
}